import scroller from 'react-scroll/modules/mixins/scroller';
import {SagaIterator} from 'redux-saga';
import {call} from 'redux-saga/effects';

/**
 * Scroll to element in payment step
 * @param {string} name - name element in payment step
 */
export function* scrollToInPaymentStep(name: string): SagaIterator {
    yield call([scroller, 'scrollTo'], name, {
        duration: 1000,
        isDynamic: true,
        offset: -100,
        smooth: true,
    });
}
